import Enum from 'enum';

export const DisplayMode = new Enum(['FULLSCREEN', 'THUMBNAIL', 'MINIMIZED']);

export const rtcStateChangeEventHandler =
    (rtcPeerConnection, callback) => (dispatch) => {
        if (rtcPeerConnection && rtcPeerConnection.connectionState) {
            // Chrome implementation
            // Goes through: connecting, connected, disconnected, failed
            rtcPeerConnection.onconnectionstatechange = () => {
                const connectionState = rtcPeerConnection.connectionState;
                dispatch(callback(connectionState));
            };
        } else {
            // 'onconnectionstatechange' is not supported in FireFox
            // Goes through: checking, connected, disconnected, closed
            rtcPeerConnection.oniceconnectionstatechange = () => {
                const connectionState = rtcPeerConnection.iceConnectionState;
                dispatch(callback(connectionState));
            };
        }
    };

export const checkDisconnectedConnectionState = (state) => {
    return state === 'disconnected';
};

export const checkFailedConnectionState = (state) => {
    return state === 'failed' || state === 'closed';
};

export const getRttMeetingValues = async (videoSenderPeer, callSession) => {
    const videoRtcPeerConnection =
        videoSenderPeer && videoSenderPeer.peerConnection;
    const videoPromise =
        videoRtcPeerConnection && videoRtcPeerConnection.getStats(null);

    const callRtcPeerConnection = callSession && callSession.connection;
    const audioPromise =
        callRtcPeerConnection && callRtcPeerConnection.getStats(null);

    const videoPromiseResult = await videoPromise;
    const audioPromiseResult = await audioPromise;

    const generateStats = (statsReport) => {
        const rtcStats = {};
        if (!statsReport) {
            return undefined;
        }
        statsReport.forEach((report) => {
            rtcStats[report.type] = report;
        });
        return rtcStats;
    };

    const videoStats = generateStats(videoPromiseResult);
    const audioStats = generateStats(audioPromiseResult);

    const videoRemoteInboundRtp =
        videoStats && videoStats['remote-inbound-rtp'];
    const audioCandidatePair = audioStats && audioStats['candidate-pair'];
    const audioRemoteInboundRtp =
        audioStats && audioStats['remote-inbound-rtp'];

    const videoRtt =
        videoRemoteInboundRtp && videoRemoteInboundRtp.roundTripTime;
    const chromeAudioRtt =
        audioCandidatePair && audioCandidatePair.currentRoundTripTime;
    const firefoxAudioRtt =
        audioRemoteInboundRtp && audioRemoteInboundRtp.roundTripTime;
    const audioRTT = chromeAudioRtt || firefoxAudioRtt;
    const audioVideoRttDiff = audioRTT - videoRtt;

    return {
        videoRtt,
        audioVideoRttDiff: isNaN(audioVideoRttDiff)
            ? undefined
            : audioVideoRttDiff,
    };
};
